export enum MinimumReturnTypeEnum {
  IRR = 'IRR',
  MARGIN = 'Margin',
  CASH_ON_CASH = 'CashOnCash',
}
